/** Layouts */
import BaseLayout from '@/views/remplacement/layouts/BaseLayout';
import EditLayout from '@/views/remplacement/layouts/EditLayout';
import ShowLayout from '@/views/remplacement/layouts/ShowLayout';

import Remplacement from '@/views/remplacement/pages/Remplacement';
import Create from '@/views/remplacement/components/remplacement/Create';
import Show from '@/views/remplacement/components/remplacement/Show';
import Edit from '@/views/remplacement/components/remplacement/Edit';
import Nettoyage from '@/views/remplacement/components/nettoyage/pages/Nettoyage';
import Chantier from '@/views/remplacement/components/chantier/pages/Chantier';
import Document from '@/views/fichier/pages/Fichier';
import names from '@/constants/routes/remplacement';
const {
  basePath,
  base,
  create,
  show,
  showDocument,
  showNettoyage,
  showChantier,
  edit,
  editDocument,
  editNettoyage,
  editChantier,
} = names;

export default [
  {
    path: basePath,
    component: BaseLayout,
    children: [
      {
        path: '',
        component: Remplacement,
        name: base,
        meta: {
          auth: true,
          permission: 'view remplacement',
        },
      },
      {
        path: 'create',
        name: create,
        component: Create,
        meta: {
          auth: true,
          permission: 'create remplacement',
        },
      },

      {
        path: 'show/:id',
        component: ShowLayout,
        children: [
          {
            path: '',
            name: show,
            component: Show,
            meta: {
              auth: true,
              permission: 'view remplacement',
            },
          },
          {
            path: 'nettoyage',
            name: showNettoyage,
            component: Nettoyage,
            meta: {
              auth: true,
              permission: 'view remplacement',
            },
          },
          {
            path: 'chantier',
            name: showChantier,
            component: Chantier,
            meta: {
              auth: true,
              permission: 'view remplacement',
            },
          },

          {
            path: 'document/:documentUuid',
            component: Document,
            name: showDocument,
            meta: {
              auth: true,
              permission: 'view remplacement',
            },
          },
        ],
      },
      {
        path: 'edit/:id',
        component: EditLayout,
        children: [
          {
            path: '',
            name: edit,
            component: Edit,
            meta: {
              auth: true,
              permission: 'view remplacement',
            },
          },
          {
            path: 'nettoyage',
            name: editNettoyage,
            component: Nettoyage,
            meta: {
              auth: true,
              permission: 'view remplacement',
            },
          },
          {
            path: 'chantier',
            name: editChantier,
            component: Chantier,
            meta: {
              auth: true,
              permission: 'view remplacement',
            },
          },

          {
            path: 'document/:documentUuid',
            component: Document,
            name: editDocument,
            meta: {
              auth: true,
              permission: 'view remplacement',
            },
          },
        ],
      },
    ],
  },
];
